import {
	Component,
	OnInit,
	ViewEncapsulation,
	Inject,
	HostBinding,
	HostListener,
} from '@angular/core';
import { FnAccordianPanelComponent } from '../fn-accordian-pannel/fn-accordian-panel.component';

@Component({
	selector: 'fn-accordian-panel-header',
	template: `
		<ng-content></ng-content> <i class="fn-global-expand fn-panel_icon"></i>
	`,

	encapsulation: ViewEncapsulation.None,
})
export class FnAccordianPanelHeaderComponent implements OnInit {
	@HostBinding('class') class = 'fn-panel-header';
	constructor(
		@Inject(FnAccordianPanelComponent)
		private fnPanel: FnAccordianPanelComponent
	) {}

	ngOnInit(): void {}
	get disable() {
		return this.fnPanel.isDisabled;
	}
	@HostListener('click')
	_toogle() {
		if (!this.disable) {
			this.fnPanel.isOpen = !this.fnPanel.isOpen;
		}
	}
}
